'use client'

import { Video } from 'lucide-react'
import MuxPlayer from '@mux/mux-player-react'

import { RichText } from '@/components/RichText'

type VideoLike = {
  muxPlaybackId?: string | null
  title?: string | null
  showTitle?: boolean | null
  caption?: any
}

type VideoBlockProps = {
  blockType: 'courseVideo'
  id?: string | null
  video?: VideoLike | string | null
}

export const VideoBlockComponent: React.FC<VideoBlockProps> = ({ video }) => {
  const media = typeof video === 'object' ? video : null
  const muxPlaybackId = media?.muxPlaybackId

  return (
    <article className="space-y-4">
      {/* Title */}
      {media?.showTitle && media?.title && (
        <h3 className="text-lg font-semibold text-foreground">{media.title}</h3>
      )}

      {/* Mux Video Player */}
      {muxPlaybackId ? (
        <div className="group relative overflow-hidden rounded-2xl bg-black shadow-xl ring-1 ring-border/30">
          <MuxPlayer
            playbackId={muxPlaybackId}
            controls
            autoPlay={false}
            style={{
              width: '100%',
              height: 'auto',
              aspectRatio: '16/9'
            }}
            title={media?.title || undefined}
            accentColor="#3b82f6"
            thumbnailTime={0}
            maxResolution="2160p"
          />
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center rounded-2xl border-2 border-dashed border-border/60 bg-muted/20 p-12 text-center">
          <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-muted">
            <Video className="h-8 w-8 text-muted-foreground" />
          </div>
          <p className="text-sm font-medium text-muted-foreground">
            Voeg een video toe met Mux Playback ID.
          </p>
        </div>
      )}

      {/* Caption (bijschrift) */}
      {media?.caption && (
        <div className="prose-content text-sm text-muted-foreground">
          <RichText data={media.caption} enableGutter={false} enableProse={false} />
        </div>
      )}
    </article>
  )
}
